const SpeciesEnum = Object.freeze([
    { id: "laks", name: "Laks" },
    { id: "aure", name: "Aure" },
    { id: "røye", name: "Røye" },
    { id: "pukkellaks", name: "Pukkellaks" },
    { id: "regnbueørret", name: "Regnbueørret" },
    { id: "annet", name: "Annet" }
 ]);
  
  export default SpeciesEnum;